import { render, staticRenderFns } from "./StandaloneGamesPage.vue?vue&type=template&id=5a1559fa&scoped=true"
import script from "./StandaloneGamesPage.vue?vue&type=script&lang=js"
export * from "./StandaloneGamesPage.vue?vue&type=script&lang=js"
import style0 from "./StandaloneGamesPage.vue?vue&type=style&index=0&id=5a1559fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1559fa",
  null
  
)

export default component.exports